import React, { FC } from 'react';
import { Box, Text, Divider, IconButton } from '@wix/design-system';
import { ChevronRight } from '@wix/wix-ui-icons-common';
import s from './MobileFilterMenuRow.module.scss';

export const getDataHooks = (dataHookPrefix: string) => ({
  container: dataHookPrefix,
  caption: `${dataHookPrefix}-caption`,
  title: `${dataHookPrefix}-title`,
});

export interface FilterData {
  dataHook: string;
  title: string;
  caption: number | string;
  onClick: () => void;
  hideDivider?: boolean;
}

export interface IClickableFilterRowProps {
  filter: FilterData;
}

const MobileFilterMenuRow: FC<IClickableFilterRowProps> = ({ filter }) => {
  const dataHooks = getDataHooks(filter.dataHook);

  return (
    <div onClick={() => filter.onClick()} className={s.filterRow}>
      <Box
        dataHook={dataHooks.container}
        align="space-between"
        verticalAlign="middle"
        paddingTop="18px"
        paddingBottom="18px"
        paddingLeft="24px"
        paddingRight="24px"
      >
        <Box direction="vertical">
          <Text weight="normal" dataHook={dataHooks.title}>
            {filter.title}
          </Text>
          <Text
            size="small"
            weight="thin"
            light
            secondary
            dataHook={dataHooks.caption}
          >
            {filter.caption}
          </Text>
        </Box>
        <Box>
          <IconButton skin="light">
            <ChevronRight />
          </IconButton>
        </Box>
      </Box>
      {filter.hideDivider ? null : (
        <Box paddingLeft="24px" paddingRight="24px">
          <Divider />
        </Box>
      )}
    </div>
  );
};

export default MobileFilterMenuRow;
